module.exports = __webpack_public_path__ + "static/media/empty.5a6724f6.svg";